import { render } from "./SectionsList.vue?vue&type=template&id=ad9b49a8&scoped=true"
import script from "./SectionsList.vue?vue&type=script&lang=js"
export * from "./SectionsList.vue?vue&type=script&lang=js"

import "./SectionsList.vue?vue&type=style&index=0&id=ad9b49a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9b49a8"]])

export default __exports__